import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { AuthenticationService } from '@sb-tools/typescript/authentication/authentication.service';

@Injectable()
export class GoogleRedirectGuard implements CanActivate {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
    ) {}

    canActivate(route: ActivatedRouteSnapshot): boolean {
        const community = this.authenticationService.community;
        const urlSearchParams = new URLSearchParams(route.queryParams);
        const googleToken = urlSearchParams.get('code');

        if (community) {
            if (googleToken) {
                this.router.navigate([`/${community}/community/installation/googleMyBusiness`], {
                    queryParams: { code: googleToken },
                });
            } else {
                this.router.navigate([`/${community}/community/installation/googleMyBusiness`]);
            }
        }

        return true;
    }
}
